import { render, staticRenderFns } from "./BulletinReadArticleComponent.vue?vue&type=template&id=3cf7b461&scoped=true&"
import script from "./BulletinReadArticleComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinReadArticleComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinReadArticleComponent.vue?vue&type=style&index=0&id=3cf7b461&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf7b461",
  null
  
)

export default component.exports